import { render } from "./PathwaysOption.vue?vue&type=template&id=5c2c2992"
import script from "./PathwaysOption.vue?vue&type=script&lang=js"
export * from "./PathwaysOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__